export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13400.e88e9d91.jpg";